import React, { useCallback } from "react";
import CustomTable, { Column } from "../../components/CustomTable";
import { useLoading } from "../../context/LoadingContext";
import { useAdminContext } from "../../context/AdminContext";
import { createupdateDeportmentModel, DepartmentResponse } from "../../model/adminModel";
import StaticModal from "../../components/staticModel";
import { Controller, SubmitHandler, useForm } from "react-hook-form";

const defaultValue = {
  department: "",
};

const DepartmentPage: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<createupdateDeportmentModel>({ mode: "all", defaultValues: defaultValue });
  const { isLoading } = useLoading();
  const [formType, setFormType] = React.useState<string>("Create");
  const [depId, setDepID] = React.useState<number | null>(null);
  const { listDepartment, getAllDepartment, getDepartmentupdate, getDepartmentCreate } = useAdminContext();

  const columns: Column<DepartmentResponse>[] = [
    { header: "Department Id", key: "id", enableLink: false, path: "" },
    {
      header: "Department Name",
      key: "department",
      enableLink: true,
      path: "/admin/department",
    },
  ];

  const getDep = useCallback(() => {
    const payload = {
      skip: 0,
      limit: 30,
    };
    getAllDepartment(payload);
  }, []);

  React.useEffect(() => {
    setValue("department", "");
    getDep();
  }, [getDep]);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setValue("department", "");
    setIsModalOpen(false);
  };

  const handleEdit = (id: number) => {
    if (id) {
      setDepID(id);
      const rData = listDepartment?.filter((item) => item.id === id);
      if (rData) {
        setFormType("Update");
        setValue("department", rData[0].department);
        openModal();
      }
    }
  };

  const onSubmit: SubmitHandler<createupdateDeportmentModel> = async (data) => {
    const Payload: createupdateDeportmentModel = {
      department: data.department,
    };
    if (formType === "Update" && depId) {
      await getDepartmentupdate(depId, Payload);
      closeModal()
    }
    if (formType === "Create") {
      await getDepartmentCreate(Payload);
      closeModal()
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <CustomTable
        showFilter={false}
        columns={columns}
        idKeyName='id'
        data={listDepartment ?? []}
        modelForm={true}
        handleModel={handleEdit}
        handleNavigation={() => {}}
      >
        <button
          onClick={() => {
            setValue('department', '')
            setFormType("Create");
            openModal();
          }}
          className='flex items-center px-4 py-2 text-sm mb-3 bg-gray-900 text-white rounded-lg focus:outline-none hover:bg-gray-600'
        >
          Add Department
        </button>
      </CustomTable>

      <StaticModal headerName={formType +' Department'} isOpen={isModalOpen} onClose={closeModal}>
        <form
          className='max-w-4xl grid gap-3 grid-cols-1 sm:grid-cols-1 md:grid-cols-1'
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className='mb-2 '>
            <label
              htmlFor='department'
              className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
            >
              Department <span className='text-red-400'>*</span>
            </label>
            <Controller
              name='department'
              control={control}
              rules={{ required: "Department is required" }}
              render={({ field }) => (
                <input
                  {...field}
                  type='text'
                  className='shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light'
                />
              )}
            />
            {errors.department && <p className='text-red-500 text-sm mt-1'>{errors.department.message}</p>}
          </div>
          <div className='max-w-4xl'>
            <button
              type='submit'
              className='text-white bg-blue-700 mr-2 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800'
            >
              Save
            </button>
            <button
              type='button'
              onClick={closeModal}
              className='text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800'
            >
              Close
            </button>
          </div>
        </form>
      </StaticModal>
    </div>
  );
};

export default DepartmentPage;

